var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-detail" },
    [
      _vm.loadingCategories || !_vm.currentProduct
        ? _c("v-skeleton-loader", { attrs: { type: "article" } })
        : _c(
            "div",
            [
              _c("h1", [_vm._v(_vm._s(_vm.currentProduct.name))]),
              _c("h3", [_vm._v(_vm._s(_vm.currentProduct.shortDescription))]),
              _c("p", {
                staticClass: "product-description mt-3 mb-6",
                domProps: { innerHTML: _vm._s(_vm.currentProduct.description) }
              }),
              _c(
                "p",
                {
                  staticClass: "price primary--text font-weight-bold mt-4 mb-0 "
                },
                [
                  !!_vm.currentProduct.basePrice
                    ? _c("strike", { staticClass: "mr-2" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("homepage.currency", {
                                price: _vm.formatThousands(
                                  _vm.currentProduct.basePrice
                                )
                              })
                            ) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("homepage.currency", {
                          price: _vm.formatThousands(
                            _vm.currentProduct.amountWithVat
                          )
                        })
                      ) +
                      " "
                  )
                ],
                1
              ),
              !!_vm.currentProduct.basePrice
                ? _c("p", { staticClass: "mb-0" }, [
                    _c("small", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("product.discountNote", {
                              price: _vm.$t("homepage.currency", {
                                price: _vm.formatThousands(
                                  _vm.currentProduct.basePrice -
                                    _vm.currentProduct.amountWithVat
                                )
                              })
                            })
                          )
                      )
                    ])
                  ])
                : _vm._e(),
              _c(
                "v-layout",
                { staticClass: "mb-3 mt-6" },
                [
                  _c("vue-numeric-input", {
                    staticClass: "ma-0",
                    attrs: { min: 1, max: 10, align: "center", size: "100px" },
                    model: {
                      value: _vm.qty,
                      callback: function($$v) {
                        _vm.qty = $$v
                      },
                      expression: "qty"
                    }
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-3",
                      attrs: { color: "primary", tile: "", depressed: "" },
                      on: {
                        click: function($event) {
                          return _vm.addToCart({
                            product: _vm.currentProduct,
                            qty: _vm.qty
                          })
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cart.addToCart")))]
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }